<template>
    <div>
        <div v-if="! section.is_active" class="flex justify-end">
            <proposal-valid-until
                :please-sign-by="proposal_document.please_sign_by"
                :mobile="false"
            />
        </div>

        <template v-if="section.is_active">
            <div class="flex justify-between items-center">
                <h2 class="text-28 lg:text-36 text-navy font-bold mt-10 mb-2" id="our_goals">
                    Our Goals
                </h2>

                <proposal-valid-until
                    :please-sign-by="proposal_document.please_sign_by"
                    :mobile="false"
                />
            </div>

            <div class="tr-box flex flex-col gap-y-8 bg-white shadow p-6 lg:p-8">
                <div class="w-full flex justify-between items-center gap-x-8">
                    <div class="flex-1">
                        <template v-if="proposal_document.logo_url">
                            <img :src="proposal_document.logo_url" alt="logo" class="object-fit max-h-24">
                        </template>
                        <template v-else>
                            <img src="/proposal-presentation-files/img/logo-placeholder.png" alt="logo" class="object-fit max-h-24">
                        </template>
                    </div>
                    <div class="flex-1">
                        <img src="https://www.thetruckersreport.com/wordpress/wp-content/themes/truckersreport/images/tr-logo.svg" alt="TruckersReport.com logo" class="object-fit max-h-24">
                    </div>
                </div>
                <ul class="tr-bullets ml-4 flex flex-col lg:grid gap-y-2 lg:gap-y-4" :class="ourGoalClass">
                    <li v-for="(bullet, index) in bullets" :key="index" v-html="bullet"></li>
                </ul>
            </div>
        </template>
    </div>
</template>

<script>
import ProposalValidUntil from "./proposal-valid-until";
import sellingPointMixin from '../sellingPointMixin';

export default {
    components: {
        ProposalValidUntil
    },
    mixins: [
        sellingPointMixin
    ],
    props: [
        'proposal_document',
        'section',
    ],
    computed: {
        bullets() {
            return this.formatBullets(this.section.content);
        },
        ourGoalClass() {
            let maxLength = 0;
            this.bullets.forEach((goal) => {
                if(goal.length > maxLength) {
                    maxLength = goal.length;
                }
            });
            
            if(maxLength < 40) {
                return 'lg:grid-cols-3';
            }
            if(maxLength < 70) {
                return 'lg:grid-cols-2';
            }

            return 'lg:grid-cols-1';
        },
    },
}
</script>